import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const EmptyState: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Card className="shadow-elegant bg-white/95 backdrop-blur-sm">
      <CardContent className="py-12 text-center">
        <FileText className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
        <h3 className="text-lg font-semibold mb-2">{t('results.surveyTemplateResults.emptyState.title')}</h3>
        <p className="text-muted-foreground mb-4">
          {t('results.surveyTemplateResults.emptyState.subtitle')}
        </p>
      </CardContent>
    </Card>
  );
};

export default EmptyState; 